import { Fragment } from "react";
import { Select, InputNumber } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { commaSeparateNumber, isArrayAndHasValue } from "../../../utils/functions";
import "./index.css";

const formatFloorLabel = (floor) => {
  if (!floor) return "";
  return floor.description ? `${floor.description} - ${floor.name || ""}` : floor.name || "";
};

const formatPartitionLabel = (partition) => {
  if (!partition) return "";
  return partition.description
    ? `${partition.description} - ${partition.name || ""}`
    : partition.name || "";
};

const getPopupContainer = (node) => node.closest(".ant-drawer-body") || document.body;

const LocationAssignForm = (props) => {
  const {
    warehouseList,
    getAllWarehouse,
    onWarehouseSelect,
    onFloorSelect,
    onPartitionSelect,
    onChangeQuantity,
    checkedItems,
    movementType,
    onCopyRow,
    copyToNextRows,
  } = props;

  const { Option } = Select;
  const qtyLabel = movementType === "incoming" ? "Receive Qty" : "Issue Qty";

  return (
    <div className="carton-location-table-wrapper">
      <div className="custome-table carton-location-table">
        <table>
          {isArrayAndHasValue(checkedItems) && (
            <thead>
              <tr>
                <th className="t-header col-warehouse">Warehouse</th>
                <th className="t-header col-floor">Floor</th>
                <th className="t-header col-partition">Partition No</th>
                <th className="t-header col-item-type">Item Type</th>
                <th className="t-header col-item">Item</th>
                <th className="t-header col-balance">Balance</th>
                <th className="t-header col-qty">{qtyLabel}</th>
                <th className="t-header col-actions">Actions</th>
              </tr>
            </thead>
          )}

          <tbody>
            {isArrayAndHasValue(checkedItems) ? (
              checkedItems.map((product, index) => (
                <Fragment key={product?.unique_id}>
                  <tr className={product?.is_add ? "is-added-item" : ""}>
                    <td className="t-body col-warehouse">
                      <div className="cell-control">
                        <Select
                          onSearch={(value) => getAllWarehouse({ name: value })}
                          onSelect={(value) => onWarehouseSelect(value, product?.unique_id)}
                          showSearch
                          placeholder="Search"
                          optionFilterProp="children"
                          size="small"
                          allowClear
                          onClear={() => getAllWarehouse()}
                          value={product?.warehouse_id}
                          getPopupContainer={getPopupContainer}
                          dropdownMatchSelectWidth={false}
                        >
                          {isArrayAndHasValue(warehouseList) &&
                            warehouseList.map((item) => (
                              <Option key={item?.id} value={item?.id} label={item?.name}>
                                {item?.name || ""}
                              </Option>
                            ))}
                        </Select>
                        <span className="copy-icon" onClick={() => copyToNextRows(product?.unique_id)}>
                          <CopyOutlined />
                        </span>
                      </div>
                    </td>
                    <td className="t-body col-floor">
                      <div className="cell-control">
                        <Select
                          onSelect={(value) => onFloorSelect(value, product?.unique_id)}
                          showSearch
                          placeholder="Floor"
                          optionFilterProp="children"
                          size="small"
                          disabled={!product?.warehouse_id}
                          value={product?.floor_id}
                          getPopupContainer={getPopupContainer}
                          dropdownMatchSelectWidth={false}
                        >
                          {isArrayAndHasValue(product?.floorsList) &&
                            product.floorsList.map((item) => (
                              <Option key={item?.id} value={item?.id} label={formatFloorLabel(item)}>
                                {formatFloorLabel(item)}
                              </Option>
                            ))}
                        </Select>
                        <span
                          className="copy-icon"
                          onClick={() => copyToNextRows(product?.unique_id)}
                          hidden={!product?.warehouse_id}
                        >
                          <CopyOutlined />
                        </span>
                      </div>
                    </td>
                    <td className="t-body col-partition">
                      <div className="cell-control">
                        <Select
                          onSelect={(value) => onPartitionSelect(value, product?.unique_id)}
                          showSearch
                          placeholder="Partition"
                          optionFilterProp="children"
                          size="small"
                          disabled={!product?.floor_id}
                          value={product?.partition_id}
                          getPopupContainer={getPopupContainer}
                          dropdownMatchSelectWidth={false}
                        >
                          {isArrayAndHasValue(product?.partitionsList) &&
                            product.partitionsList.map((item) => (
                              <Option key={item?.id} value={item?.id} label={formatPartitionLabel(item)}>
                                {formatPartitionLabel(item)}
                              </Option>
                            ))}
                        </Select>
                        <span
                          className="copy-icon"
                          onClick={() => copyToNextRows(product?.unique_id)}
                          hidden={!product?.floor_id}
                        >
                          <CopyOutlined />
                        </span>
                      </div>
                    </td>
                    <td className="t-body col-item-type">
                      <span className="cell-text">{product?.item_type_name || "—"}</span>
                    </td>
                    <td className="t-body col-item">
                      <span className="cell-text">{product?.item_name || "—"}</span>
                    </td>
                    <td className="t-body col-balance">
                      {product?.balance_quantity ? commaSeparateNumber(Number(product.balance_quantity).toFixed(2)) : 0}
                    </td>
                    <td className="t-body col-qty">
                      <div className="cell-control">
                        <InputNumber
                          style={{ width: 90 }}
                          placeholder="Qty"
                          formatter={(value) => commaSeparateNumber(value)}
                          size="small"
                          onChange={(value) => onChangeQuantity(value, product?.unique_id)}
                          value={product?.req_qty ?? 0}
                        />
                        <span className="copy-icon" onClick={() => copyToNextRows(product?.unique_id)}>
                          <CopyOutlined />
                        </span>
                      </div>
                    </td>
                    <td className="t-body col-actions">
                      <span onClick={() => onCopyRow(product, index)} style={{ cursor: "pointer" }}>
                        <CopyOutlined />
                        <span className="ml-2">Copy</span>
                      </span>
                    </td>
                  </tr>
                </Fragment>
              ))
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LocationAssignForm;
